import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IExamdate } from "../../../Pages/ExamDate/IExamDate";

export const ListExamdateSlice = createSlice({
  name: "ListExamdateSlice",
  initialState: {} as IReduxState<IExamdate[]>,
  reducers: {
    listExamdate: (state) => {
      state.isLoading = true;
    },
    successlistExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistExamdate, listExamdate, successlistExamdate } =
  ListExamdateSlice.actions;

export default ListExamdateSlice.reducer;
